import { Accordion } from 'flowbite-react';
const MachineLearningFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                         What types of ML models do you build?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We build a wide range of machine learning models, including supervised learning models such as classification and regression, unsupervised learning for clustering and segmentation, time series forecasting, anomaly detection systems, and ensemble models. These models are custom-developed to address your specific business needs and improve predictive accuracy.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       How do you choose the right model for our business problem?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Model selection depends on the nature of your data, business objectives, and problem complexity. We analyze your data characteristics and task type, whether classification, regression, or clustering, and then select algorithms that optimize performance, interpretability, and scalability to align with your enterprise goals.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What data do we need to start ML model development?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           To start, you need relevant historical data that represents your business processes well. This includes structured or unstructured data with sufficient volume, quality, and features. Data should be clean, labeled (for supervised tasks), and cover variability to support robust model training and validation.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How long does it take to develop and deploy a custom ML model?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Development and deployment cycles typically range from a few weeks to a few months. This timeline depends on data availability, problem complexity, feature engineering needs, model training, testing, and deployment logistics within your existing ML infrastructure.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       How do you ensure model accuracy and prevent overfitting?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We use techniques like cross-validation, hyperparameter tuning, feature engineering, and regularization to maximize accuracy while avoiding overfitting. Ensemble methods and rigorous testing across multiple datasets help ensure models generalize well to real-world data.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What happens after the model is deployed?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Post-deployment, models are continuously monitored for performance and drift. We implement automated alerts and retraining pipelines to adapt to data changes and evolving business conditions, ensuring sustained accuracy and reliability of production-ready ML models.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                      Can ML models integrate with our existing enterprise systems?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Yes, our ML models are designed to integrate seamlessly with your enterprise IT landscape. We use APIs, cloud ML platforms, and containerized deployment to ensure compatibility with your current databases, applications, and infrastructure for scalable ML solutions.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you handle model drift and performance degradation?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We proactively monitor model performance metrics to detect drift or accuracy drops. When detected, models are retrained or fine-tuned using updated data sets. A combination of automated MLops pipelines and manual review maintains long-term model effectiveness aligned with business needs.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default MachineLearningFAQ;
